import type { TodoCategory } from "../../lib/calendarTodos.js";

// One place that maps a todo category to its token classes, so the grid circles,
// the day card and the filter chips can never drift apart. Colours are the
// existing -bg/-fg token pairs (light and dark both defined in tokens.css).
// A circle is the -fg colour with the -bg tint as its letter, which stays
// legible in either theme.
export interface CategoryStyle {
  chip: string;
  dot: string;
  circle: string;
  check: string;
  checkOn: string;
}

export const CATEGORY_STYLE: Record<TodoCategory, CategoryStyle> = {
  important: { chip: "bg-[var(--color-error-bg)] text-[color:var(--color-error-fg)]", dot: "bg-[var(--color-error-fg)]", circle: "bg-[var(--color-error-fg)] text-[color:var(--color-error-bg)]", check: "border-[color:var(--color-error-fg)]", checkOn: "bg-[var(--color-error-fg)] text-[color:var(--color-error-bg)]" },
  work:      { chip: "bg-[var(--color-info-bg)] text-[color:var(--color-info-fg)]", dot: "bg-[var(--color-info-fg)]", circle: "bg-[var(--color-info-fg)] text-[color:var(--color-info-bg)]", check: "border-[color:var(--color-info-fg)]", checkOn: "bg-[var(--color-info-fg)] text-[color:var(--color-info-bg)]" },
  reminder:  { chip: "bg-[var(--color-warning-bg)] text-[color:var(--color-warning-fg)]", dot: "bg-[var(--color-warning-fg)]", circle: "bg-[var(--color-warning-fg)] text-[color:var(--color-warning-bg)]", check: "border-[color:var(--color-warning-fg)]", checkOn: "bg-[var(--color-warning-fg)] text-[color:var(--color-warning-bg)]" },
  travel:    { chip: "bg-[var(--color-cyan-bg)] text-[color:var(--color-cyan-fg)]", dot: "bg-[var(--color-cyan-fg)]", circle: "bg-[var(--color-cyan-fg)] text-[color:var(--color-cyan-bg)]", check: "border-[color:var(--color-cyan-fg)]", checkOn: "bg-[var(--color-cyan-fg)] text-[color:var(--color-cyan-bg)]" },
  personal:  { chip: "bg-[var(--color-accent-bg)] text-[color:var(--color-accent-fg)]", dot: "bg-[var(--color-accent-fg)]", circle: "bg-[var(--color-accent-fg)] text-[color:var(--color-accent-bg)]", check: "border-[color:var(--color-accent-fg)]", checkOn: "bg-[var(--color-accent-fg)] text-[color:var(--color-accent-bg)]" },
};

export function formatTime(hhmm: string): string {
  const [h, m] = hhmm.split(":").map(Number);
  return new Date(2000, 0, 1, h ?? 0, m ?? 0).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export function formatDayTitle(dateKey: string): string {
  return new Date(`${dateKey}T00:00:00`).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
}
